import React, { useEffect, useRef } from "react";
import {
  Box,
} from "@chakra-ui/react";
import Hero from "components/Hero";
import WorkflowDemo from "components/WorkflowDemo";
import Features from "components/Features";
import Footer from "components/Footer";
import SEO from "components/SEO";

function Home() {
  const pricingRef = useRef(null);
  const showPricing = false; // v1 release: Pricing disabled

  useEffect(() => {
    if (window.location.hash === "#pricing" && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>
      <SEO />
      <Hero />
      <Box id="workflow-section">
        <WorkflowDemo />
      </Box>
      <Features />

      {showPricing && (
        <div id="pricing-section" ref={pricingRef}>
          {/* <Pricing /> */}
        </div>
      )}

      <Footer />
    </>
  );
}

export default Home;
